import React, { Component } from 'react'
import FormsRenderer from './FormsRenderer'
import injectStyles from 'react-jss'
import FieldsRenderer from './FieldsRenderer'

const styles = {
  page: {
    padding: 20,
    margin: 20,
    marginLeft: 60,
    backgroundColor: '#ffffff',
    border: '1px solid #ebedf0',
    borderRadius: 2,
    padding: 26,
    width: 500,
    boxSizing: 'border-box',
  },
  pageNameContainer: {
    margin: 0,
    paddingLeft: 20,
    paddingRight: 20,
  },
  pageNameInput: {
    fontSize: 24,
    border: 'none',
    backgroundColor: 'transparent',
    fontWeight: 400,
    marginTop: 20,
    marginBottom: 20,
  },
}

class Page extends Component {

  constructor(props){
    super(props)
    const page = props.screenState[props.pageKey]
    this.state = {
      pageName: page['name'],
    }
  }

  onStateChange = (newScreenState, newLayoutFormKeys) => {
		var {
      pageKey,
      onStateChange,
      getScreenState,
    } = this.props


    newScreenState = Object.assign({}, getScreenState(), newScreenState)

		// Update the form's layout with the new fields if the fields have changed
		if (newLayoutFormKeys != newScreenState[pageKey]['layout']){
			newScreenState[pageKey]['layout'] = newLayoutFormKeys
		}

		onStateChange(newScreenState)

	};

  onPageNameChange = (e) => this.setState({ pageName: e.target.value });

  onPageNameBlue = (e) => {
    const { pageName } = this.state
    const { pageKey, onControlUpdate, nestedLayout } = this.props
    onControlUpdate(pageKey, {
      name: pageName,
    }, nestedLayout)
  }

  render = () => {
    const {
			screenState,
			renderedForms,
      componentMap,
      deleteChildScreen,
      extraFieldProps,
      getChildScreenSchema,
      nestedLayout,
      onControlUpdate,
      onLoadChildScreen,
      classes,
      readOnly,
      getScreenState,
      SideControl,
      dragging,
      onDrop,
      pageKey,
    } = this.props
    const { pageName } = this.state

    return <div className={classes.page}>
      <div className={classes.pageNameContainer}>
        <input
          className={classes.pageNameInput}
          onBlur={this.onPageNameBlur}
          onChange={this.onPageNameChange}
          value={pageName}
          placeholder="Page name..."
        />
      </div>
      <FormsRenderer
        screenState={screenState}
        // When in edit mode this is required
        getScreenState={getScreenState}
        renderedForms={renderedForms}
        componentMap={componentMap}
        deleteChildScreen={deleteChildScreen}
        extraFieldProps={extraFieldProps}
        getChildScreenSchema={getChildScreenSchema}
        nestedLayout={nestedLayout}
        onControlUpdate={onControlUpdate}
        onLoadChildScreen={onLoadChildScreen}
        readOnly={readOnly}
        onStateChange={this.onStateChange}
        SideControl={SideControl}
        FieldsRenderer={FieldsRenderer}
        dragging={dragging}
        onDrop={onDrop}
      />
    </div>
  }
}

export default injectStyles(styles)(Page)



// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/Page.js